"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cardo = void 0;
var utils_1 = require("../utils");
var base_1 = require("./base");
// Cardo only has 400 & 700 (no 500). So for Opal, we want all the same settings as the base except weight 400
exports.cardo = (0, utils_1.overrideTypographyStyles)(base_1.opalBase, { weight: 400 });
//# sourceMappingURL=cardo.js.map